import React, { Suspense, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { history } from "../../_redux/_store/history";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import {
  Grid,
  Tooltip,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  TableContainer,
  TableHead,
  Table,
  TableCell,
  TableBody,
  TableRow,
  Snackbar
} from "@material-ui/core";
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import CancelIcon from '@material-ui/icons/Cancel'
import MuiContainer from "@material-ui/core/Container";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import { makeStyles, withStyles } from "@material-ui/styles";
import HelpBlockImg from "../../_assets/_images/helpBlock.png";
import ErrorHandler from "../updateHandlers/ErrorHandler";
import { AnomalySignalsComponent } from "../scopedFindingRule/SignalsDialog";
import CreateAnomalyRule from "./CreateAnomalyRule";
import useDebounce from "../../utilities/useDebounce";
import { useEffect } from "react";
import {
  clearAnomalyState,
  fetchAnomalyType,
} from "../../_redux/_actions/anomalyRuleActions";
import {
  persistAnomalyRuleFilter,
  persistSelectedAnomalyRule,
} from "../../_redux/_actions/detailsPersistActions";
import {deleteAnomalyRule, saveDeletedAnomalyRule} from "../../_redux/_actions/anomalyRuleActions";
import {fetchSelectScopedAnomalyRule} from "../../_redux/_actions/selectScopedAnomalyRuleAction";
import BreadcrumbDispatch from '../../_partials/breadcrumbDispatch';
import queryString from "query-string";
import SkeletonTableList from '../skeleton/SkeletonTableList.jsx'

const StyledTableCell = withStyles((theme) => ({
  head: {
    color: 'white',
  },
  body: {
    fontSize: 14,
  },
}))(TableCell)

const useStyles = makeStyles(() => ({
  detailsPaper: {
    margin: "40px 0px",
    backgroundColor: "#F6F6F6",
    padding: "30px",
  },
  containerPaper: {
    height: "100%",
    padding: "30px",
    opacity: "1",
  },
  separator: {
    margin: "8px 15px",
  },
  label: {
    width: "88px",
  },
  icon: {
    color: "#ACACAC",
    margin: "5px",
  },
  editButton: {
    color: "#52A1C2",
  },
  deleteButton: {
    background: "white",
    color: "black",
  },
  textEditButton: {
    color: "blue",
    "&:hover": {
      backgroundColor: "inherit",
    },
  },
  paragraph:{
    marginBottom:'10px',
    marginTop:'10px'
  },
  deleteRuleTable:{
    marginTop:'10px'
  },
  Button: {
    width: '120px',
    marginRight: '20px',
    '&:hover': {
      background: '#52A1C2',
    },
  },
}));

const SelectAnomalyRuleComponent = React.memo(() => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [scopedAnomalyOpen, setScopedAnomalyOpen] = useState(false);
  const [createSuccess, setCreateSuccess] = useState(false);
  const [scroll, setScroll] = React.useState("paper");
  const [openAnomalyDelete, setOpenAnomalyDelete] = useState(false)
  const [anomalyID, setAnomalyID] = useState('');
  const [createdAnomaly, setCreatedAnomaly] = useState('');
  const [anomalyScope, setAnomalyScope] = useState('');
  const [successMsg, setSuccessMsg] = useState(false)
  const [warning, setWarning] = useState(false);
  const ruleId = useSelector((state) => state.anomalyRule.ruleId);
  const error = useSelector((state) => state.anomalyRule.error);
  const queryValues = queryString.parse(history.location.search);
  const {machine_type, hmi_type} = queryValues;

  const selectScopedAnomalyRuleResponse = useSelector(
    (state) => state.selectScopedAnomalyRule
  );
  const debounce = useDebounce();

  useEffect(() => {
    async function fetchAll() {
      await dispatch(fetchAnomalyType(machine_type,hmi_type))
    }
    fetchAll()
    return () => {
      dispatch(clearAnomalyState());
    };
  }, []);

  useEffect(() => {
    if (selectScopedAnomalyRuleResponse.selectScopedAnomalyRule) {
      setAnomalyScope(selectScopedAnomalyRuleResponse.selectScopedAnomalyRule);
    }
  }, [selectScopedAnomalyRuleResponse]);

  const handleConfirmation = (rule, selectedEntities) => {
    dispatch(persistSelectedAnomalyRule(rule));
    dispatch(persistAnomalyRuleFilter(selectedEntities));
    history.push(`/rules/select_anomaly_rule/select_scoped_anomaly_rule?machine_type=${machine_type}&hmi_type=${hmi_type}&anomalyRuleId=${rule.id}`);
  };

  const openDeleteAnomaly = (rule, selectedEntities) =>{
    setOpenAnomalyDelete(true)
    setAnomalyID(rule.id)
    dispatch(
      fetchSelectScopedAnomalyRule({
        anomaly_rule_id: rule.id,
        machine_type: machine_type,
        hmi_type:hmi_type
      })
    );
    dispatch(persistAnomalyRuleFilter(selectedEntities));
  }

  const deleteAnomalyRuleFunc = () =>{
    dispatch(deleteAnomalyRule(anomalyID,machine_type,hmi_type,handleDeleteAnomalyRule))  
    dispatch(saveDeletedAnomalyRule(anomalyID))
    setOpenAnomalyDelete(false)
  }

  const handleDeleteAnomalyRule = (value)=>{
    if (value) {
      setSuccessMsg(true)
    } else {
      setSuccessMsg(false)
      setWarning(true)
    }
  }

  const handleCreateDialog = () => {
    setOpen(true);
  };
  const handleCloseDialog = () => {
    setOpen(false);
  };

  const handleCreateScopedAnomaly = (ruleId) => {
    if (ruleId) {
      setOpen(false);
      setScopedAnomalyOpen(true);
    }
  };

  //Successful creation of scope
  const createSuccessFlag = (rule) => {
    setCreatedAnomaly(rule)
    setCreateSuccess(true);
  };

  const handleCreateSuccessDialog = () => {
    setCreateSuccess(false);
    debounce(() =>
      history.push(
        `/rules/select_anomaly_rule/select_scoped_anomaly_rule?machine_type=${machine_type}&hmi_type=${hmi_type}&anomalyRuleId=${createdAnomaly.id}`
      )
    );
  };

  const CreateSuccessDialog = () => {
    return (
      <Dialog
        open={createSuccess}
        onClose={handleCreateSuccessDialog}
        style={{
          padding: "20px",
        }}
      >
        <DialogContent>Anomaly Rule created successfully</DialogContent>
        <DialogActions>
          <Button onClick={handleCreateSuccessDialog} color="primary" autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const AnomalySignals = (props) => {
    const handleCreateAnomalyDialog = () =>{
      setOpen(true);
    }
    return (
      <AnomalySignalsComponent props={props}  handleCreateAnomalyDialog={handleCreateAnomalyDialog} />
    );
  };

  return (
    <>
      <Grid container spacing={3}>
        <BreadcrumbDispatch />
        <Grid item md={9}>
          {error && <ErrorHandler message={error} />}
          <Paper className={classes.containerPaper} >
            <Grid container>
              <Grid item container>
                <Grid item container xs={8}>
                  <Typography className="text-secondary" variant="h5">
                    Select Anomaly Rule
                  </Typography>
                  <Tooltip title="question">
                    <HelpOutlineIcon className={classes.icon} />
                  </Tooltip>
                </Grid>
                <Grid item xs={4} style={{display:"flex", justifyContent: "end"}}>
                  <Button
                    variant="outlined"
                    onClick={() => handleCreateDialog()}
                  >
                    + CREATE NEW
                  </Button>
                </Grid>
              </Grid>
              {
                <Grid item style={{ width: "100%" }}>
                  <AnomalySignals
                    scroll={scroll}
                    handleUpdate={handleConfirmation}
                    anomalyRuleComponent={true}
                    handleDelete={openDeleteAnomaly}
                    moduleFrom ={"select_anomaly_rule"}
                  />
                  {open && <CreateAnomalyRule
                    open={open}
                    handleCloseDialog={handleCloseDialog}
                    handleCreateScopedAnomaly={handleCreateScopedAnomaly}
                    scroll={scroll}
                    createSuccessFlag={createSuccessFlag}
                    initiateFunctionCall={true}
                  />}
                  {createSuccess && <CreateSuccessDialog />}
                </Grid>
              }
            </Grid>
          </Paper>
        </Grid>
        <Grid item md={3} className="helpBlock">
          <Paper className={classes.containerPaper}>
            <Box component="div" className="helpBlockTitle">
              Help
            </Box>

            <Box component="div" className="helpBlockImg">
              <img
                src={HelpBlockImg}
                alt="HelpBlockImg"
                className="img-fluid"
                style={{ display: "block", margin: "auto", width: "100%" }}
              />
            </Box>
          </Paper>
        </Grid>
        <Grid>
          <Dialog
            open={openAnomalyDelete}
            onClose={() => setOpenAnomalyDelete(false)}
            maxWidth={'md'}
            PaperProps={{ style: { width: '50em', height: '30em' } }}
          >
            <DialogContent style={{ overflow: 'hidden' }}>
              <Grid item container direction='column' justifyContent='center'>
                <Grid
                  container
                  direction='row'
                  justifyContent='space-between'
                  style={{marginTop: '2em' }}
                >
                  <Grid item>
                    <Typography style={{ color: 'Red', fontWeight: 1000 }}>
                      Attention
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Button
                        onClick={() => setOpenAnomalyDelete(false)}
                    >
                      <CancelIcon style={{ color: '#666666' }} />
                    </Button>
                  </Grid>
                </Grid>
                <Grid item className={classes.paragraph}>
                  <p>
                    Deleting this anomaly rule will also result in removing
                    following Scoped Anomaly Rules
                  </p>
                </Grid>
                <Grid item style={{height:'200px'}}>
                  <TableContainer
                    component={Paper}
                    className={classes.deleteRuleTable}
                  >
                    <Table >
                      <TableHead>
                        <TableRow style={{ backgroundColor: 'grey' }}>
                          <StyledTableCell>
                            <Typography style={{ color: 'white' }}>
                              Scope
                            </Typography>
                          </StyledTableCell>
                          <StyledTableCell align='left'>
                            <Typography style={{ color: 'white' }}>
                              Note Text
                            </Typography>
                          </StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                       {!selectScopedAnomalyRuleResponse && <SkeletonTableList count={2}/>}
                        { anomalyScope ?
                            (anomalyScope.map((row,id) =>
                              <TableRow
                                style={{ height: 10 }}
                                key={`delete${row.scope}`}
                              >
                                <TableCell component='th' scope='row'>
                                  {row.scope}
                                </TableCell>
                                <TableCell component='th' scope='row'>
                                  {row.note_text}
                                </TableCell>
                              </TableRow>
                            ))
                          : null
                        }
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
                <Grid container direction='row' style={{ marginTop: '10px' }}>
                  <Grid item>
                    <Button
                      className={classes.Button}
                      onClick={() => deleteAnomalyRuleFunc()}
                    >
                      CONFIRM
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      onClick={() => setOpenAnomalyDelete(false)}
                      className={`${classes.Button} btn-white`}
                    >
                      CANCEL
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </DialogContent>
          </Dialog>
        </Grid>

        {/* Pop up to show if the delete anomaly rule  has been successful */}
        <Dialog
        open={successMsg}
        onClose={() => setSuccessMsg(false)}
        maxWidth={'md'}
        PaperProps={{ style: { width: '30em', height: '20em' } }}
        >
        <DialogContent style={{ padding: '30px' }}>
          <Grid
            item
            container
            direction='column'
            justifyContent='center'
            alignItems='center'
          >
            <Grid item>
              <CheckCircleOutlineIcon
                style={{ width: '3em', height: '3em', color: '#52A1C2' }}
              />
            </Grid>
            <Grid item style={{ marginTop: '20px', marginBottom: '20px' }}>
              Anomaly Rule has been deleted successfully
            </Grid>
            <Grid item>
              <Button
                onClick={() => setSuccessMsg(false)}
                className={classes.Button}
                variant='outlined'
              >
                <Typography>OK</Typography>
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
        </Dialog>

        {/* error message on delete anomaly failure  */}
        {warning && 
          <Snackbar
            message={"Delete anomaly rule failure"}
            open={warning ? true : false}
            autoHideDuration={3000}
            onClose={() => setWarning(false)}
          />
        }
      </Grid>
    </>
  );
});

export default function SelectAnomalyRule() {
  
  useEffect(()=>{
    if(!history.location.search)
    {
      history.push('/rules');
      return;
    }
  },[])

  return (
    <Suspense fallback="">
      <SelectAnomalyRuleComponent />
    </Suspense>
  );
}
